// extracted by mini-css-extract-plugin
export default {"wrapper":"RoundInfoItem_wrapper__St95R","info":"RoundInfoItem_info__79L7A"};